<script>
    import { onMount } from 'svelte';
    import { goto, url, isActive } from '@roxi/routify';
    import { postFormData, getData, isLoggedIn } from '../helpers.js';
    // import Icon from 'svelte-awesome';
    // import { bars } from 'svelte-awesome/icons';
    
    let mobile_extended = false;

    //protected route, check if logged in
	onMount(async () => {
		isLoggedIn().then((res) => {
			if(res) {
			// do nothing (logged in)
			} else {
				$goto('./login');
			};
		}).catch(() => {
			// assume not logged in if there's an error.
			$goto('./login');
		});
	});

    function handleLogout() {
        let res = getData('logout');
		res.then(response => response.json())
		.then(ret_json => {
			if (ret_json.status === 'success') {
				$goto('/');
			} else if (ret_json.status === 'error') {
				let errors = ret_json.error;
				console.log(errors);
                browser.cookies.remove({
                    url: document.location.hostname,
                    name: "session",
                });
                $goto('/')
			}
		});
    }

    const links = [
        ['./dashboard', 'Dashboard'],
        ['./ecpr-search', 'eCPR Search'],
        ['./wage-report', 'Theft Report'],
        ['./pwc100-search', 'PWC100'],
        ['./history', 'History'],
        ['./faq', 'FAQs']
    ];

    function extendMobileNavbar() {
        mobile_extended = !mobile_extended;
        if (mobile_extended) {
            document.getElementById('navbar').parentElement.style.overflowY = 'hidden';
            document.getElementById('navbar').parentElement.style.position = 'fixed';
        } else {
            document.getElementById('navbar').parentElement.style.overflowY = 'auto';
            document.getElementById('navbar').parentElement.style.position = 'unset';
        }
    }
</script>

<!--Hacky method to switch between mobile and desktop
    There's probably a better way to implement in Svelte
    But this method works.
    TODO: FIX INTO SVELTE METHOD RATHER THAN TAILWIND BREAKPOINTS
-->
<div id='navbar'>
    <div class="relative w-full lg:hidden mb-5 bg-gray-100 shadow-md">
        <div class="w-max mx-auto">    
            <a href="/dashboard">
                <div class="w-max p-5 text-center text-2xl font-bold font-mono">
                    <img class="logo h-8" src="./ref/padg_lockup_invert.svg" alt="Palo Alto Data Group Logo">
                </div>
            </a>
        </div>
        <!-- From svelte-awesome; but the library takes too long to compile. -->
        <div class="absolute z-[120] top-5 left-5" on:click={extendMobileNavbar}>
            <svg version="1.1" class="inline-block" width="27.428571428571427" height="32" role="presentation" viewBox="0 0 1536 1792" style="font-size: 2em; fill:currentColor">
                <path id="path-0" d="M1536 1344v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 832v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45zM1536 320v128q0 26-19 45t-45 19h-1408q-26 0-45-19t-19-45v-128q0-26 19-45t45-19h1408q26 0 45 19t19 45z"></path>
            </svg>
            <!-- <Icon data={bars} scale="2"/> -->
        </div>
        {#if mobile_extended}
            <div id="grey-out" class="absolute top-0 left-0 h-screen w-screen opacity-30 bg-black z-[100]"
                on:click={extendMobileNavbar}>
            </div>
            <div class="absolute top-0 left-0 pt-10 h-screen bg-gray-50 z-[110]">
                <nav class="flex flex-col mt-8 ml-auto">
                    {#each links as [path, name]}
                        <a href={$url(path)}>
                            <button class="navbutton border-r-0 h-full w-full {$isActive(path) ? 'current-tab' : ''}">
                                <div class="w-auto h-full px-4">
                                    {name}
                                </div>
                            </button>
                        </a>
                    {/each}
                    
                    <button class="navbutton border-r-0 absolute w-full bottom-0 align-bottom" on:click={() => handleLogout()}>
                        <div class="w-auto h-full">
                            Logout
                        </div>
                    </button>
                </nav>
            </div>
        {/if}
    </div>
    <div class="hidden lg:flex mb-5 bg-gray-100 shadow-md">
        <a href="/dashboard">
            <div class="py-5 px-5 text-left text-2xl font-bold font-mono">
                <img class="logo h-8" src="./ref/padg_lockup_invert.svg" alt="Palo Alto Data Group Logo">
            </div>
        </a>
        <nav class="flex ml-auto">
            {#each links as [path, name]}
                <a href={$url(path)}>
                    <button class="navbutton w-full h-full {$isActive(path) ? 'current-tab' : ''}">
                        <div class="w-auto h-full">
                            {name}
                        </div>
                    </button>
                </a>
            {/each}
            <button class="navbutton" on:click={() => handleLogout()}>
                <div class="w-auto h-full">
                    Logout
                </div>
            </button>
        </nav>
    </div>
</div>

<style>
    .navbutton {
        @apply py-5 px-5 rounded-none text-gray-800;
    }
    .navbutton:hover {
        @apply bg-gray-200;
    }
    .navbutton.current-tab {
        @apply bg-gray-600 hover:bg-gray-600 text-gray-200 border-0;
    }
</style>